import { Icon } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.less';

const cx = classNames.bind(styles);


const defaultProps = {
  description: '',
  zoneTitle: '',
  zoneAction: '',
};
const propTypes = {
  isOver: PropTypes.bool.isRequired,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  zoneTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  zoneAction: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};

// TODO: style issue with position of description should be fixed
const ColumnsDropzone = ({
  isOver,
  description,
  children,
  zoneTitle,
  zoneAction,
}) => (
  <React.Fragment>
    {(!_.isEmpty(zoneTitle) || !_.isEmpty(zoneAction)) &&
      <div className={cx('columns-zone-header')}>
        {zoneTitle}
        {zoneAction}
      </div>
    }
    <div className={cx('columnsDz', {
        hover: isOver,
        filled: !_.isEmpty(children) && children.length,
      })}
    >
      {/* NOTES: children can be either an object or an array of object, if not specified by parent component, the value is undefined */}
      {_.isEmpty(children) ? (
        <div className={cx('iconWrapper')}>
          <Icon type="plus" className={cx('icon')} />
          {description}
        </div>
      ) : children}
    </div>
  </React.Fragment>
);

ColumnsDropzone.defaultProps = defaultProps;
ColumnsDropzone.propTypes = propTypes;
export default ColumnsDropzone;



// WEBPACK FOOTER //
// ./src/components/ui/Dropzones/ColumnsDropzone.jsx